import React, { useState } from 'react';
import PB101Tasks from './PB101Tasks';
import PB101Records from './PB101Records';
import PB101Overview from './PB101Overview';
import PB101NewRecord from './PB101NewRecord';
import PB101RecordDetail from './PB101RecordDetail';
import PB101OutcomeModal from './PB101OutcomeModal';

const TABS = ['Daily Tasks', 'Records', 'Overview'];

export default function PB101Module() {
  const [tab, setTab]               = useState('Daily Tasks');
  const [selectedId, setSelectedId] = useState(null);
  const [showNew, setShowNew]       = useState(false);
  const [outcomeRecord, setOutcomeRecord] = useState(null);

  if (selectedId) {
    return (
      <div className="module-page">
        <PB101RecordDetail
          recordId={selectedId}
          onBack={() => setSelectedId(null)}
          onLogContact={(record) => setOutcomeRecord(record)}
        />
        {outcomeRecord && (
          <PB101OutcomeModal
            record={outcomeRecord}
            onClose={() => setOutcomeRecord(null)}
            onSaved={() => { setOutcomeRecord(null); }}
          />
        )}
      </div>
    );
  }

  return (
    <div className="module-page">
      {showNew && (
        <PB101NewRecord
          onClose={() => setShowNew(false)}
          onCreated={(id) => { setShowNew(false); if (id) setSelectedId(id); }}
        />
      )}

      {/* Header */}
      <div className="module-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <span style={{ fontSize: 22 }}>🎓</span>
          <h1 className="module-title">PB101</h1>
        </div>
        <button className="btn btn-primary btn-sm" onClick={() => setShowNew(true)}>+ New Record</button>
      </div>

      {/* Tabs — always at top */}
      <div className="module-tabs">
        {TABS.map(t => (
          <button
            key={t}
            className={`module-tab ${tab === t ? 'active' : ''}`}
            onClick={() => setTab(t)}
          >
            {t}
          </button>
        ))}
      </div>

      {/* Content */}
      {tab === 'Daily Tasks' && <PB101Tasks onSelectRecord={setSelectedId} />}
      {tab === 'Records'     && <PB101Records onSelectRecord={setSelectedId} />}
      {tab === 'Overview'    && <PB101Overview />}
    </div>
  );
}
